import { useCustomFormContext } from "@/components/site-builder/modules/CustomFormModule/context/customFormContext";
import TextField from "@/components/site-builder/TextField";
import { TitleSize } from "@/constants/content";
import { createBasicHeaderFieldObject } from "@/utils/site-builder/createBasicTextFieldObject";
import s from "./FormTitle.module.scss";

export default function FormTitle() {
  const {
    formEntity: {
      data: { name },
    },
  } = useCustomFormContext();

  if (!name) return null;

  return (
    <TextField
      type="title"
      field={createBasicHeaderFieldObject(name, TitleSize.H3)}
      className={s.title}
    />
  );
}
